<template>
  <div ref="containerRef" class="h-full w-full"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const containerRef = ref(null);

const emit = defineEmits(['ready']);

onMounted(() => {
  if (containerRef.value) {
    emit('ready', containerRef.value);
  }
});
</script>
